// extracted by mini-css-extract-plugin
export default {"hideTooltip":"rqa-z","fadeIn":"sqa-z","delay":"tqa-z","recommendedSizeTooltip":"uqa-z"};